import { ProposalFeedSkeleton } from '@/components/launchpad/proposal-feed-skeleton';
import { Skeleton } from '@/components/ui/app-skeleton';
import { LISTING_INDEX_PAGE_STACK_CLASS } from '@/lib/ui/layout';

const TOOLBAR_ICON_KEYS: readonly string[] = ['tb-0', 'tb-1', 'tb-2', 'tb-3'];

export default function LaunchpadLoading(): React.ReactNode {
  return (
    <div className={LISTING_INDEX_PAGE_STACK_CLASS}>
      {/* Title row — aligns with LaunchpadHeader: h1 title + toolbar icons + Launch button.
          The toolbar buttons are transparent `tertiary` icon buttons (gap-0), so the
          skeleton renders a small centred glyph per size-9 slot — not a filled block —
          otherwise the four merge into one blob. */}
      <div className="flex items-center justify-between gap-2">
        <Skeleton className="h-7 w-28 shrink-0" />
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-0">
            {TOOLBAR_ICON_KEYS.map((key) => (
              <div key={key} className="flex size-9 items-center justify-center">
                <Skeleton className="size-4 rounded-full" />
              </div>
            ))}
          </div>
          <Skeleton className="hidden h-9 w-32 rounded-control sm:block" />
        </div>
      </div>

      <ProposalFeedSkeleton />
    </div>
  );
}
